import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 15.5c3 -1 5.5 -.5 8 4.5c.5 -3 1.5 -5.5 3 -8","key":"svg-0"}],["path",{"d":"M18 9a2 2 0 1 1 0 -4a2 2 0 0 1 0 4","key":"svg-1"}]]

/**
 * IconBounceRight
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYm91bmNlLXJpZ2h0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00IDE1LjVjMyAtMSA1LjUgLS41IDggNC41Yy41IC0zIDEuNSAtNS41IDMgLTgiIC8+CiAgPHBhdGggZD0iTTE4IDlhMiAyIDAgMSAxIDAgLTRhMiAyIDAgMCAxIDAgNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/bounce-right
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBounceRight = createReactComponent('outline', 'bounce-right', 'BounceRight', __iconNode);

export default IconBounceRight;